var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "command" }, [
    _vm._v(_vm._s(_vm.shell)),
    _c("code", [
      _vm._v(_vm._s(_vm.basePath)),
      _c("strong", [
        _vm._v(
          _vm._s(_vm.cmd) + _vm._s(_vm.cmdSuffix) + " " + _vm._s(_vm.args)
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }